import VuexDataTable from "./VuexDataTable";
import DataTableHeaderFilters from "./DataTableHeaderFilters"
import DataTableFilter from "./DataTableFilter";
import DataTableDateFilter from "./DataTableDateFilter";
import DataTableSelectFilter from "./DataTableSelectFilter";
import DataTableEmptyFilter  from "./DataTableEmptyFilter";

export default {
    install(Vue) {
        Vue.component("a-vuex-data-table", VuexDataTable);
        Vue.component("a-data-table-header-filters", DataTableHeaderFilters);
        Vue.component("a-data-table-filter", DataTableFilter);
        Vue.component("a-data-table-date-filter", DataTableDateFilter);
        Vue.component("a-data-table-select-filter", DataTableSelectFilter);
        Vue.component("a-data-table-empty-filter", DataTableEmptyFilter);
    }
}
